<template>
  <div class="dashboard-card">
    <div class="card-header">
      <awesomeIcon icon="chart-bar" /> Haalbaarheid over tijd
    </div>
    <div class="card-graph">
      <GChart
        :settings="{ packages: ['corechart'], language: 'nl-nl' }"
        :data="data"
        :options="options"
        :events="chartEvents"
        type="ComboChart"
      />
    </div>
    <div id="scores-tooltip"></div>
  </div>
</template>

<script>
export default {
  name: 'ScoresWidget',
  data() {
    return {
      chartType: 'ComboChart',
      options: {
        height: 300,
        colors: JSON.parse(JSON.stringify(process.env.VUE_APP_STYLE === 'db' ? ['#6c0', '#006'] : this.$store.state.colorScheme)),
        legend: {
          position: 'none',
        },
        chartArea: {
          left: 65,
          top: 25,
          bottom: 30,
          right: 20,
          width: '100%',
          height: '100%',
        },
        seriesType: 'line',
        interpolateNulls: true,
        series: {
          0: {
            pointSize: 7,
          },
          1: {
            type: 'line',
            lineWidth: 1,
          },
        },
        hAxis: {
          textStyle: {
            fontSize: 12,
          },
        },
        vAxis: {
          minValue: 0,
          maxValue: 100,
          format: '#\'%\'',
          gridlines: { color: '#eee' },
          textStyle: {
            fontSize: 13,
          },
        },
        tooltip: {
          trigger: 'none',
        },
      },
      columns: [
        {
          type: 'date',
          label: 'Date',
        },
        {
          type: 'number',
          label: 'Haalbaarheid',
        },
        {
          type: 'number',
          label: 'Alertwaarde',
        },
      ],
      chartEvents: {
        onmouseover: this.setTooltipContent,
        onmouseout: () => { this.setTooltipContent(null); },
      },
    };
  },
  created() {
    this.options.colors[1] = 'red';
  },
  computed: {
    rows() {
      return this.$parent.scores;
    },
    data() {
      return [this.columns].concat(this.rows);
    },
  },
  methods: {
    getWeekNumber(d) {
      // Copy date so don't modify original
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
      // Get first day of year
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      // Calculate full weeks to nearest Thursday
      return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    },
    setTooltipContent(object) {
      const tooltip = document.getElementById('scores-tooltip');
      if (object !== null) {
        tooltip.style.display = 'block';
        tooltip.innerHTML = `<b>${this.rows[object.row][0] ? `Week ${this.getWeekNumber(this.rows[object.row][0])} - ${this.rows[object.row][0].getFullYear()} - ` : ''}${this.columns[object.column].label}</b>: ${this.formatPrice(this.rows[object.row][object.column], true)}%`;
      } else {
        tooltip.style.display = 'none';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  #scores-tooltip {
    padding: 10px 20px;
    background-color: #fcf8e3;
    color: #8a6d3b;
    display: block;
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    display: none;
    pointer-events: none;
    border-radius: $br;
  }
  .card-graph {
    padding-bottom: 10px;
    min-height: 300px;
  }
</style>
